import { DayOfWeek } from '@sit/types';

const ONE_DAY = 1;
const FIFTEEN_DAYS = 15;
const FIRST_OF_MONTH = 1;
const MID_OF_MONTH = 16;

/**
 * This must only be used during initial loads. Use `company.weekendDays` with this as a fallback.
 */
const defaultWeekends = ['saturday', 'sunday'] satisfies DayOfWeek[];

export { FIFTEEN_DAYS, FIRST_OF_MONTH, MID_OF_MONTH, ONE_DAY, defaultWeekends };
